<template>
	<vx-card class="pie-chart-card h-full">
		<vue-apex-charts
			class="w-full h-full flex justify-center items-center"
			style="padding: 0 7px"
			height="350px"
			ref="apexChart"
			type="donut"
			:options="options"
			:series="series"
		/>
	</vx-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';

export default {
	name: "PieChartCard",
	components: {
		VueApexCharts
	},
	props: {
		chartOptions: { required: true },
		labels: { default: () => [] },
		series: { default: () => [] },
	},
	computed: {
		options() {
			const labels = { labels: this.labels }
			return Object.assign({}, this.chartOptions, labels);
		}
	}
};
</script>

<style lang="scss">
.pie-chart-card {
	.vx-card {
		&__collapsible-content,
		&__body {
			height: 100%;
		}
	}
}
</style>
